import { UserRole } from "../enums/user-role.enum";
import { Permission } from "./permission.enum";

export const RolePermissions: Record<UserRole, Permission[]> = {
  [UserRole.ADMIN]: [
    Permission.USERS_READ,
    Permission.USERS_CREATE,
    Permission.USERS_UPDATE,
    Permission.USERS_DELETE,
    Permission.ADMINS_READ,
    Permission.ADMINS_CREATE,
    Permission.ADMINS_UPDATE,
    Permission.ADMINS_DELETE,
    Permission.ROLES_READ,
    Permission.ROLES_CREATE,
    Permission.ROLES_UPDATE,
    Permission.ROLES_DELETE,
    Permission.SYSTEM_SETTINGS_READ,
    Permission.SYSTEM_SETTINGS_UPDATE,
    Permission.AUDIT_LOGS_READ,
    Permission.ADMIN_NOTIFICATIONS_READ,
    Permission.ADMIN_NOTIFICATIONS_UPDATE,
    Permission.USER_NOTIFICATIONS_READ,
    Permission.USER_NOTIFICATIONS_UPDATE,
    Permission.USER_NOTIFICATIONS_CREATE,
    Permission.DASHBOARD_READ,
    Permission.BACKGROUND_TASKS_READ,
    Permission.LISTINGS_READ,
    Permission.LISTINGS_IMPORT,
    Permission.BOOKINGS_READ,
    Permission.USERS_VERIFICATION,
    Permission.FINANCE_READ,
    Permission.FINANCE_UPDATE,
    Permission.POINTS_HISTORY_READ,
  ],
};
